var render = function render(){var _vm=this,_c=_vm._self._c;return _c('va-action-button',{attrs:{"item":_vm.item,"hide-label":_vm.icon,"label":"Download Report","icon":"mdi-cloud-download-outline","color":"success","text":""},on:{"click":_vm.downloadReport}})
}
var staticRenderFns = []

export { render, staticRenderFns }